export enum GuaranteeStatusEnum {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  ACTIVATED = "ACTIVATED",
  REJECTED = "REJECTED",
  FINISHED = "FINISHED"
}